import { pathToRegexp } from 'path-to-regexp';

import type { PartialMetadataMap } from '@xing-com/crate-core-assets';
import { getEntryPointConfig } from '@xing-com/crate-xinglet/internal';

import type { Route } from './extract-routes';
import { extractRoutes } from './extract-routes';

export type RouteMatcher = (url: string) => Route | undefined;

export function getPath(url: string): string {
  return url.split(/[?#]/, 1)[0];
}

export function createRouteMatcher(
  metadataMap: PartialMetadataMap,
  entryPoint: string
): RouteMatcher {
  const { site } = getEntryPointConfig(metadataMap, entryPoint);
  const matchPairs: [RegExp, Route][] = [];
  for (const route of extractRoutes(metadataMap, site)) {
    matchPairs.push([pathToRegexp(route.path).regexp, route]);
    if (route.catchAll) {
      matchPairs.push([pathToRegexp(`${route.path}/*splat`).regexp, route]);
    }
  }

  return (url) => {
    return matchPairs.find(([regexp]) => regexp.test(getPath(url)))?.[1];
  };
}
